<template>
  <div id="data-list-list-view" class="data-list-container">
    <FilterList />
    <add
      :isSidebarActive="promptAddSidebar"
      :customers="customers"
      :services="services"
      :incidents="incidents"
      :departements="departements"
      :add-call-back="addCallBack"
      :getServices="getServices"
      :getIncidents="getIncidents"
      @closeSidebar="toggleAddSidebar"
    />
    <update
      :isSidebarActive="promptUpdateSidebar"
      :customers="customers"
      :services="services"
      :incidents="incidents"
      :departements="departements"
      :update-call-back="updateCallBack"
      :getServices="getServices"
      :getIncidents="getIncidents"
      :form="choosen_problem"
      @closeSidebar="toggleUpdateSidebar"
    />
    <close
      :isPromptActive="promptClose"
      :closeCallBack="closeCallBack"
      :problem="choosen_problem"
      @closePrompt="toggleClosePrompt"
    />
    <vs-table ref="table" :max-items="itemsPerPage" :data="problems">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            v-if="
              profile != '1' &&
              profile != '6' &&
              profile != '2' &&
              profile != '7'
            "
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Nouveau problème</span>
          </div>
          <div
            @click="refresh()"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            v-model="stringSearch"
            @keypress.enter="findProblems()"
            type="text"
            class="input-search vs-table--search-input"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <template slot="thead">
        <vs-th width="2%" sort-key="ref">N° TICKET</vs-th>
        <vs-th width="30%" sort-key="title">Titre</vs-th>
        <vs-th width="5%" sort-key="status">Statut</vs-th>
        <vs-th width="1%" sort-key="">Nbr incidents</vs-th>
        <vs-th width="10%" sort-key="customer">Client</vs-th>
        <vs-th width="10%" sort-key="service">Application</vs-th>
        <vs-th width="2%" sort-key="departement">Service</vs-th>
        <vs-th width="10%" sort-key="arrived_at">Date création</vs-th>
        <vs-th width="10%" sort-key="arrived_at">Date clôture</vs-th>
        <vs-th width="2%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ tr.ref }}</vs-td>
            <!-- <vs-td> {{ tr.title }} </vs-td> -->
            <vs-td> <read-more more-str="Voir plus" :text="tr.title" link="#" less-str="Voir moins" :max-chars="20"></read-more> </vs-td>
            <vs-td>
              <vs-chip>{{ tr.status }}</vs-chip>
            </vs-td>
            <vs-td> {{ tr.incident_list.length }} </vs-td>
            <vs-td> {{ tr.customer }} </vs-td>
            <vs-td> {{ tr.service }} </vs-td>
            <vs-td> {{ tr.departement }} </vs-td>
            <vs-td>
              <p class="product-price">{{ tr.created_at | title }}</p>
            </vs-td>
            <vs-td>
              <p class="product-price">{{ tr.closed_at | title }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <div class="flex" @click="$router.push({path: '/problems-details/' + tr.id})">
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>
                <div
                  class="flex"
                  v-if="tr.closed_at == null"
                  @click="showUpdateForm({ ...tr })"
                >
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="ml-2"
                  />
                </div>
                <div
                  class="flex"
                  v-if="tr.closed_at == null"
                  @click="(promptClose = true), (choosen_problem = tr)"
                >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="ml-2"
                  />
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import FilterList from "./components/FilterList.vue";

import { _buildQuery } from "../../helpers/helper";
import Add from "./components/add.vue";
import Close from "./components/close.vue";
import Update from "./components/update.vue";

export default {
  components: {
    FilterList,
    Add,
    Close,
    Update,
  },
  name: "problems-all",
  data() {
    return {
      last_page: 1,
      page: 1,
      filterPrompt: false,
      stringSearch: "",

      customers: [],
      services: [],
      departements: [],

      selected: [],
      problems: [],
      itemsPerPage: 50,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      profile: "",
      filter: {
        page: 1,
        client: "",
        status: "",
      },

      stats: {
        total: 0,
        total_in_progress: 0,
        total_closed: 0,
        total_received: 0,
      },
      promptAddSidebar: false,
      promptUpdateSidebar: false,
      incidents: [],
      promptClose: false,
      choosen_problem: {
        customer_id: "",
        title: "",
        departement_id: "",
        service_id: "",
        incident_list: [],
      },
      incident_list: [],
    };
  },
  watch: {
    page(value) {
      if (this.stringSearch) {
        this.findProblems();
      } else {
        this.getProblems(value, this.stringSearch);
      }
    },
  },
  computed: {
    base() {
      return this;
    },
  },
  methods: {
    async getStatsByStatus(stringSearch) {
      // try {
      //   let { client, status } = this.filter;
      //   let params = {
      //     stringSearch,
      //     client,
      //     status
      //   };
      //   let response = await this.$http.get(
      //     "requests/stats-requests" + _buildQuery(params)
      //   );
      //   if (response.data) {
      //     this.stats.total = response.data.requestTotal;
      //     this.stats.total_in_progress = response.data.requestTotalInProgress;
      //     this.stats.total_closed = response.data.requestTotalClosed;
      //     this.stats.total_received = response.data.requestTotalReceived;
      //   }
      // } catch (error) {
      //   console.log("error: ", error);
      // }
    },
    refresh() {
      this.stringSearch = "";
      this.page = 1;
      this.getProblems(this.page, this.stringSearch);
    },

    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },

    addNewData() {
      this.toggleDataSidebar(true);
      this.getCustomers();
      this.getDepartements();
    },

    toggleDataSidebar(val = false) {
      this.promptAddSidebar = val;
    },
    toggleClosePrompt(val = false) {
      this.promptClose = val;
    },
    toggleAddSidebar(val = false) {
      if (val == false) {
        this.choosen_problem = {};
      }
      this.promptAddSidebar = val;
    },
    toggleUpdateSidebar(val = false) {
      this.promptUpdateSidebar = val;
    },

    async getProblems(page, stringSearch) {
      try {
        this.$vs.loading();
        let { client, status } = this.filter;
        let response = await this.$http.get(
          "problems" + _buildQuery({ client, status, stringSearch, page })
        );
        this.problems = response.data.data;
        this.last_page = response.data.last_page;
        // this.getStatsByStatus(this.page, this.stringSearch);
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        console.log(error);
      }
    },
    async findProblems() {
      if (this.stringSearch) {
        try {
          this.$vs.loading();
          let params = {
            page: this.page,
            search: this.stringSearch,
          };
          let response = await this.$http.get("problems/find" + _buildQuery(params));
          this.problems = response.data.data;
          this.last_page = response.data.last_page;
          // this.getStatsByStatus(this.page, this.stringSearch);
          this.$vs.loading.close();
        } catch (error) {
          console.log(error);
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          console.log(error);
        }
      } else {
        this.getProblems(this.page, this.stringSearch);
      }
    },
    async getDepartements() {
      try {
        // this.$vs.loading();
        let response = await this.$http.get("departements");
        this.departements = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    async getServices(customer_id, departement_id) {
      try {
        // this.$vs.loading();
        let params = {
          customer_id: customer_id,
          departement_id: departement_id,
        };
        let response = await this.$http.get("services" + _buildQuery(params));
        this.services = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    async getCustomers() {
      // this.$vs.loading();
      let response = await this.$store.state.customers({}).catch((error) => {
        console.log("error: ", error);
      });
      this.$vs.loading.close();

      this.customers = response.data;
    },
    addCallBack() {
      this.getProblems(1, this.stringSearch);
    },
    closeCallBack() {
      this.getProblems(this.page, this.stringSearch);
    },
    updateCallBack() {
      this.getProblems(this.page, this.stringSearch);
    },
    async callBackFilter(search) {
      let { page, client, status } = search;
      this.$vs.loading();
      this.filter.client = search.client;
      this.filter.status = search.status;
      let stringSearch = this.stringSearch;
      let response = await this.$store.state
        .requests(this.filter, {
          page,
          stringSearch,
          client,
          status,
        })
        .catch((error) => {
          console.log("error: ", error);
        });
      this.last_page = response.data.last_page;
      this.requestDatas = response.data.data;
      // this.getStatsByStatus(this.page, this.stringSearch);
      this.$vs.loading.close();
    },
    async showUpdateForm(problem) {
      this.choosen_problem = problem;
      this.getCustomers();
      this.getDepartements();
      this.getServices(problem.customer_id, problem.departement_id);
      this.getIncidents(
        problem.customer_id,
        problem.departement_id,
        problem.service_id
      );
      this.toggleUpdateSidebar(true);
    },

    async getIncidents(customer_id, departement_id, service_id) {
      try {
        // this.$vs.loading();
        let params = {
          customer: customer_id,
          departement: departement_id,
          service: service_id,
        };
        let response = await this.$http.get(
          "problems/incidents" + _buildQuery(params)
        );
        this.incidents = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
  },
  async mounted() {
    this.profile = window.GETCCMT.$store.state.AppActiveUser.profile_id;
    this.getProblems(this.page, this.stringSearch);
    // this.getStatsByStatus(this.page, this.stringSearch);
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: right;
    }
  }
}

#readmore {
  font-weight: bold;
  text-decoration: underline;
}
</style>
